import { Component, OnInit, ViewChild } from "@angular/core";
import * as _ from "underscore";
import * as moment from "moment";
import { TagService } from "../../services/tag.service";
import { Tag } from "../../models/tag.model";
import { EditSearchTagModalComponent } from "./edit-search-tag-modal.component";
import { ToastService } from "../../components/toast/toast.service";
import { DeleteConfirmationModalComponent } from "../../components/modal/modals/delete-confirmation-modal.component";
import { LowyGridComponent } from "../../components/grid/grid.component";

@Component({
  templateUrl: "./manage-search-tags.component.html",
  styleUrls: ["manage-search-tags.component.scss"],
  providers: [TagService],
})
export class ManageSearchTagsComponent implements OnInit {
  @ViewChild("grid") grid: LowyGridComponent;
  @ViewChild("editSearchTag") editSearchTag: EditSearchTagModalComponent;
  @ViewChild("deleteSearchTag")
  deleteSearchTag: DeleteConfirmationModalComponent;

  // we end up with index 0 being the selectAll checkbox, and the rows starting at i=1, see html
  public checkboxes: Array<{
    isChecked: boolean;
    attachment: any;
    element: any;
  }>;

  public tags: Tag[];

  constructor(
    private toastService: ToastService,
    private tagService: TagService
  ) {}

  public async editTag(tag: Tag) {
    this.editSearchTag.open(tag);
  }

  public async deleteTag(tag: Tag) {
    this.deleteSearchTag.open({
      data: tag,
      headline: "Delete " + tag.name,
      subheading:
        "Are you sure you want to delete the search tag " + tag.name + "?",
    });
  }
  public async confirmDeleteTag(tag: Tag) {
    try {
      await this.tagService.adminDeleteTag(tag.tagId);
      this.toastService.throwToast("Tag deleted");
      this.ngOnInit();
    } catch (err) {
      this.toastService.throwToast("Error deleting tag: " + err);
    }
  }

  public async newTag() {
    this.editSearchTag.open();
  }

  async ngOnInit() {
    this.tags = await this.tagService.adminGetTags();
    this.tags = _.map(this.tags, (tag) => {
      tag["dataTypeName"] = tag["dataTypes"] ? tag["dataTypes"][0].name : null;
      return tag;
    });
    this.grid.dataReady(
      this.tags,
      ["checkbox", "dataType", "name", "dataTypeName", "description"],
      ["checkbox", "dataType", "Name", "Type", "Description"]
    );
  }

  public async downloadAllRecords(downloadType: string) {
    this.grid.downloadFiles(downloadType, this.tags);
  }
}



// WEBPACK FOOTER //
// ./src/app/home/manage-search-tags/manage-search-tags.component.ts